import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Ref from "./pages/Ref";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./pages/Home";
import ErrorCom from "./Components/ErrorCom";
import TasksList from "./pages/Tasks";
import ReferralRewards from "./pages/Rewards";
import Dashboard from "./pages/Dashboard";
import NotAdmin236 from "./pages/NotAdmin236";
import Settings from "./pages/Settings";
import EditTasks from "./pages/EditTasks";
import TwitterTasks from "./pages/TwitterTasks";
import ExtrenalTasks from "./pages/ExtrenalTasks";
import Search from "./pages/Search";
import Statistics from "./pages/Statistics";
import { AuthContextProvider } from "./context/AuthContext";
import GoldHunters from "./pages/GoldHunters";
import GoldHand from "./pages/GoldHand";
import LeaderBoard from "./pages/LeaderBoard";
import DailyCheckIn from "./pages/Checkin";
import Airdrop from "./pages/Airdrop";
import AdminRanks from "./pages/AdminRanks";
import eruda from "eruda";
import TelegramT from "./pages/TelegramTask";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <ErrorCom />,
    children: [
      {
        path: "/",
        element: <GoldHunters />,
      },
      {
        path: "/ref",
        element: <Ref />,
      },
      {
        path: "/tasks",
        element: <TasksList />,
      },
      {
        path: "/ghand",
        element: <GoldHand />,
      },
      {
        path: "/leaders",
        element: <LeaderBoard />,
      },
      {
        path: "/rewards",
        element: <ReferralRewards />,
      },
      {
        path: "/checkin",
        element: <DailyCheckIn />,
      },
      {
        path: "/airdrop",
        element: <Airdrop />,
      },
      {
        path: "/dashboardadmin36024x",
        element: <NotAdmin236 />,
      },
    ],
  },
  {
    path: "/dashboardAdx",
    element: <Dashboard />,
    errorElement: <ErrorCom />,
    children: [
      {
        path: "/dashboardAdx/settings",
        element: <Settings />,
      },
      {
        path: "/dashboardAdx/managetasks",
        element: <EditTasks />,
      },
      {
        path: "/dashboardAdx/telegramtasks",
        element: <TelegramT />,
      },
      {
        path: "/dashboardAdx/twittertasks",
        element: <TwitterTasks />,
      },
      {
        path: "/dashboardAdx/ranks",
        element: <AdminRanks />,
      },
      {
        path: "/dashboardAdx/externaltasks",
        element: <ExtrenalTasks />,
      },
      {
        path: "/dashboardAdx/search",
        element: <Search />,
      },
      {
        path: "/dashboardAdx/stats",
        element: <Statistics />,
      },
    ],
  },
]);

eruda.init();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthContextProvider>
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  </AuthContextProvider>
);
